export default "__VITE_ASSET__BGtUUnpi__"